import script from "./GuestSchoolDetailComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./GuestSchoolDetailComponent.vue?vue&type=script&setup=true&lang=js"

import "./GuestSchoolDetailComponent.vue?vue&type=style&index=0&id=04b2d491&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04b2d491"]])

export default __exports__